export default class TelecomSimDto {
    constructor(obj) {
        this.id = obj.id
        this.lineNumber = obj.lineNumber
        this.comment = obj.comment
        this.openDate = obj.openDate
        this.headers = ['lineNumber', 'openDate', 'comment']
    }
}
